<template>
  <div>
      <p class="detail-table-name">Working Time</p>
      <table class="detail-table w-100">
        <thead>
          <th>University</th>
          <th>Campus</th>
          <th>Lesson</th>
          <th>Substitute</th>
          <th>Waiting</th>
          <th>Late</th>
          <th>Absent</th>
          <th>Work on day with no classes</th>
        </thead>
        <tbody>
          <tr
            v-for="workingTime of workingTimesFields"
            :key="workingTime.index"
            :class="{ 'total': workingTime.category === 'total' }"
          >
            <template v-if="workingTime.unit === 'hour'">
              <td>{{ workingTime.university }}</td>
              <td>{{ workingTime.campus || '-' }}</td>
              <td>{{ workingTime.lesson }} Hr</td>
              <td>{{ workingTime.substitute }} Hr</td>
              <td>{{ workingTime.waiting }} Hr</td>
              <td>{{ workingTime.late }} Hr</td>
              <td>{{ workingTime.absent }} Hr</td>
              <td>-</td>
            </template>
            <template v-else>
              <td>{{ workingTime.university }}</td>
              <td>{{ workingTime.campus || '-' }}</td>
              <td>{{ workingTime.lesson }}</td>
              <td>{{ workingTime.substitute }}</td>
              <td>{{ workingTime.waiting }}</td>
              <td>{{ workingTime.late }}</td>
              <td>{{ workingTime.absent }}</td>
              <td>{{ workingTime.workOnHoliday }}</td>
            </template>
          </tr>
        </tbody>
      </table>
      <p class="unit-name">Unit: Lessons</p>
    </div>
</template>

<script lang="ts">
import _ from 'lodash'
import { Component, Prop, Vue } from 'vue-property-decorator'
import {
  category,
  Timesheet,
  unit,
  WorkingTime,
} from '@/store/timesheets/types'
import { Moment } from 'moment'

@Component
export default class WorkingTimeComponent extends Vue {
  @Prop() date!: Moment

  @Prop() workingTimes!: WorkingTime[]

  get workingTimesFields(): {
    category: category // 集計カテゴリ
    unit: unit // 集計単位
    university: string // 大学名
    campus: string|null // キャンパス名
    lesson: number|string // レッスン
    substitute: number|string // 代講
    waiting: number|string // ウェイティング
    late: number|string // 遅刻
    absent: number|string // 欠席
    workOnHoliday: number|string|null // 時間外休日勤務
  }[] {
    const times = _.chain(this.workingTimes)
      .map((workingTime) => {
        const base = _.pick(workingTime, [
          'category',
          'unit',
          'lesson',
          'substitute',
          'waiting',
          'late',
          'absent',
          'workOnHoliday',
        ])

        let university = workingTime.university?.name || ''
        if (workingTime.category === 'total') {
          if (workingTime.unit === 'lesson') {
            university = 'Total'
          } else if (workingTime.unit === 'hour') {
            university = 'Total (Hour)'
          }
        }

        return {
          university,
          campus: workingTime.campus?.name || null,
          ...base,
        }
      })
      .value()

    return times
  }
}
</script>

<style scoped>
.detail-table-name {
  border-left:3px solid #BFBFBF;
  padding-left:5px;
  margin-bottom:10px;
  font-weight: bold;
}

.detail-table {
  table-layout: fixed;
  border-collapse:collapse;
  margin-bottom:10px;
}

.detail-table th {
  padding:10px;
  text-align: center;
}

.detail-table td {
  padding:10px;
  text-align: center;
}

.detail-table thead {
  background: #fff;
  border: 2px solid #dcdcdc
}

.detail-table tbody:nth-child(odd) {
  background: #D8D8D8;
}

.detail-table tbody tr:nth-child(even) {
  background: #fff;
}

.detail-table tbody tr.total {
  background: #D8E2F3;
}

.unit-name {
  text-align: right;
}
</style>
